<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Detail Blast List
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link :to="'/blast-list/edit?id=' + blastList.id" class="btn px-15 btn-warning text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-edit fs-16"></i>
                                Edit
                            </router-link>
                            <router-link to="/blast-list" class="btn px-15 btn-secondary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-arrow-left fs-16"></i>
                                Kembali
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <div v-if="loading" class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else-if="blastList">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label><strong>Nama Blast List:</strong></label>
                                        <p>{{ blastList.name }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label><strong>Status:</strong></label>
                                        <p>
                                            <span v-if="blastList.status == 'active'" class="badge badge-success">Active</span>
                                            <span v-else-if="blastList.status == 'inactive'" class="badge badge-secondary">Inactive</span>
                                            <span v-else-if="blastList.status == 'draft'" class="badge badge-warning">Draft</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label><strong>Deskripsi:</strong></label>
                                        <p>{{ blastList.description || 'Tidak ada deskripsi' }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label><strong>Dibuat:</strong></label>
                                        <p>{{ convertDateToLocal(blastList.created_at) }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label><strong>Diperbarui:</strong></label>
                                        <p>{{ convertDateToLocal(blastList.updated_at) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center">
                            <p>Blast List tidak ditemukan</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                loading: false,
                blastList: null
            };
        },
        mounted() {
            this.loadBlastList();
        },
        methods: {
            convertDateToLocal(date) {
                return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
            },
            async loadBlastList() {
                this.loading = true;
                try {
                    const id = this.$route.query.id;
                    if (!id) {
                        this.$router.push('/blast-list');
                        return;
                    }
                    
                    let response = await this.$store.dispatch('blast_list_one', { id });
                    this.blastList = response.data.data.blast_list;
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || 'Server error');
                    this.$router.push('/blast-list');
                }
                this.loading = false;
            }
        }
    };
</script>


